/**
 * Dataset mock dello storico accessi dell'utente loggato (AccessEntry), esposto
 * da GET /user/auditLog. Proiezione read-only di eventi di accesso Liferay: non
 * ha audit fields di dominio, solo id/date/action/ip/browser. L'handler pagina
 * questa lista lato server come fa il backend reale.
 */

import type { AccessEntry } from '../../entities/auditLog/auditLogTypes';

export const mockAuditLog: AccessEntry[] = [
  { id: 1, date: '2026-07-30T08:12:00Z', action: 'login', ip: '192.168.1.20', browser: 'Chrome 126 / Windows' },
  { id: 2, date: '2026-07-29T17:45:00Z', action: 'logout', ip: '192.168.1.20', browser: 'Chrome 126 / Windows' },
  { id: 3, date: '2026-07-29T09:03:00Z', action: 'login', ip: '192.168.1.20', browser: 'Chrome 126 / Windows' },
  { id: 4, date: '2026-07-28T14:20:00Z', action: 'login', ip: '10.0.0.5', browser: 'Firefox 128 / macOS' },
  { id: 5, date: '2026-07-28T08:00:00Z', action: 'add', ip: '10.0.0.5', browser: 'Firefox 128 / macOS' },
  { id: 6, date: '2026-07-27T18:30:00Z', action: 'logout', ip: '10.0.0.5', browser: 'Firefox 128 / macOS' },
  { id: 7, date: '2026-07-27T08:55:00Z', action: 'login', ip: '10.0.0.5', browser: 'Firefox 128 / macOS' },
];
